import * as tslib_1 from "tslib";
import * as React from 'react';
import omit from 'lodash/omit';
import cn from 'astro-classname';
import '../card/index.css';
var BLACK_LIST = [
    'className',
    'width',
    'prefix',
    'title',
    'img',
    'theme',
    'underline',
    'cornerLeft',
    'cornerRight',
    'type'
];
var Card = (function (_super) {
    tslib_1.__extends(Card, _super);
    function Card() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Card.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, title = _b.title, img = _b.img, theme = _b.theme, width = _b.width, type = _b.type, underline = _b.underline, prefix = _b.prefix, cornerLeft = _b.cornerLeft, cornerRight = _b.cornerRight, style = _b.style, children = _b.children;
        var classes = cn(prefix, className, (_a = {},
            _a[prefix + "-" + type] = type === 'row',
            _a[prefix + "-" + theme] = theme && theme !== 'default',
            _a));
        var nodeProps = omit(this.props, BLACK_LIST);
        var styles = style || {};
        width && (styles.width = width);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, nodeProps, { style: styles }),
            type !== 'row' && img && React.createElement("div", { className: prefix + "-img-wrapper" }, img),
            title && React.createElement("div", { className: prefix + "-title" }, title),
            React.createElement("div", { className: prefix + "-body" }, children),
            type !== 'row' && underline && React.createElement("div", { className: prefix + "-underline" }),
            type !== 'row' && (cornerLeft || cornerRight) && (React.createElement("div", { className: prefix + "-corner-wrapper" },
                cornerLeft && React.createElement("div", { className: prefix + "-corner-left" }, cornerLeft),
                cornerRight && React.createElement("div", { className: prefix + "-corner-right" }, cornerRight)))));
    };
    Card.defaultProps = {
        className: '',
        type: 'column',
        prefix: 'zhui-card'
    };
    return Card;
}(React.Component));
export default Card;
